import { initReportObservable, RawReportType } from '@datadog/browser-core';
export function trackReportError(configuration, errorObservable) {
  const subscription = initReportObservable(configuration, [RawReportType.cspViolation, RawReportType.intervention]).subscribe(rawError => errorObservable.notify(rawError));
  return {
    stop: () => {
      subscription.unsubscribe();
    }
  };
}
